import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  CostProfile,
  Id,
  Identifiable,
  Resource,
  WeeklyCalendar,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedResource: boolean;
  resource: Identifiable<Resource> & {
    costProfile: Identifiable<CostProfile> | null;
    weeklyCalendar: Identifiable<WeeklyCalendar>;
  };
  retrieveResource(request: Boundaries["retrieveResource"]["request"]): void;
}

function useResourceRetrieval(id: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isResourceRetrievalRequestPending(id),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isResourceRetrievalRequestSuccess(id),
    ),
    isRequestFailure: useSelector(() =>
      selector.isResourceRetrievalRequestFailure(id),
    ),
    hasRetrievedResource: useSelector(() => selector.hasRetrievedResource(id)),
    resource: useSelector(() => selector.getResource(id)),
    retrieveResource: core.retrieveResource,
  };
}

export { useResourceRetrieval };
